<template>
  <router-view />
</template>

<script>
export default {
  name: 'ClimbingGroupsCrewIndex'
}
</script>
